import { RegistereRibbonButton, useAppInfo, useModelDrivenApp, useRibbon, useSelectionContext } from "@eavfw/apps";
import { useEAVForm } from "@eavfw/forms";
import { useClientContext, useJsonFetcher } from "@eavfw/manifest";
import { useMemo } from "react";


RegistereRibbonButton("CUSTOM_RIBBON_VIEW_LOI", ({ key, ...props }) => {
    const { registerButton, events } = useRibbon();
    const { currentEntityName, currentRecordId } = useAppInfo();
    const { baseUrl } = useClientContext();

    let [loidocumentpdfid] = typeof currentRecordId !== "undefined" ? useEAVForm(x => x.formValues.loidocumentsignedpdfid ?? x.formValues.loidocumentpdfid) : [];
    const { selection, selectionDetails } = typeof currentRecordId === "undefined" ? useSelectionContext() : { selection: undefined, selectionDetails: undefined };

    const app = useModelDrivenApp();
    const [_baseUrl, fetcher] = useJsonFetcher();
    console.log("CUSTOM_RIBBON_VIEW_LOI:", [loidocumentpdfid, selection, selectionDetails]);

    registerButton({
        key: key,
        text: props.text,
        iconProps: props.iconProps ?? { iconName: 'Send' },
        title: props.title ?? props.text,
        disabled: !(loidocumentpdfid ?? selection?.getSelection()[0]?.loidocumentpdfid) || ((selection?.getSelectedCount()??0) > 1),
        onClick: () => {
            setTimeout(async () => {
                console.log("CUSTOM_RIBBON_VIEW_LOI:", [loidocumentpdfid, selection]);
                //loidocumentpdfid = loidocumentpdfid ?? selection?.getSelection()[0]?.loidocumentpdfid;
                //if (!loidocumentpdfid) {
                //    alert('Document not generated yet...');
                //    return;
                //}
                // .filter latest created document
                const latestDocument = await fetcher(`/api/entities/documents?$filter=startswith(path,'/${currentRecordId ?? selection?.getSelection()[0].id}%27)%20and%20endswith(path,'.pdf')&$select=id,createdon&pretty&$top=1&$orderby=createdon desc&$endswith('.pdf')`, {})
                console.log(latestDocument);
                if (!latestDocument?.items?.[0]?.id) {
                        alert('Document not generated yet...');
                        return;
                }

                window.open(`${baseUrl}/files/${latestDocument.items[0].id}`, '_blank');
            });
        }
        //workflow: props.workflow
        // onClick: onClick
    }, [loidocumentpdfid, selectionDetails]);

});

